import React from "react";
import { ls } from "../../locale";

import { Row, Col } from "react-bootstrap";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import "./index.scss";

export default function() {

  const rError = ls.t('Error');
  let message = rError.Transaction || '';
  message = message.split(/[\r\n]/);

  if(!Array.isArray(message)) message = [];

  return (
    <div className={"main-container search-page"}>
      <div className="header-con">
        <Header />
      </div>
      <div className="header-bar" />
      <div className="container padt80 padb20">
        <Row className="min-height">
          <Col className="error-message-container">
            <p>Dear Guest,</p>
            <p>Thank you for choosing <a href="https://www.salamair.com">SalamAir</a> !</p>
            <p>Unfortunately, our online service is not available at this time. 
              Please contact our call center to book a flight. 
              Sorry for the inconvinence.
            </p>
            
            <p>Phone: +968 24272222</p>
            <p>Email: booking@salamair.com</p>
            
            <p>Regards,</p>
            <p>SalamAir</p>
          </Col>
        </Row>
      </div>
      <Footer />
    </div>
  )
}